import type { BadgeTone } from '@/components/base/Badge';
import type { TransactionOrigin } from '@/types/portal';

export const originMeta: Record<
  TransactionOrigin,
  { label: string; icon: string; tone: BadgeTone; sourceLabel: string }
> = {
  single: {
    label: 'Single payment',
    icon: 'ri-send-plane-line',
    tone: 'primary',
    sourceLabel: 'Open Single Payment',
  },
  bulk: {
    label: 'Bulk batch',
    icon: 'ri-stack-line',
    tone: 'secondary',
    sourceLabel: 'Open Bulk Payments',
  },
  topup: {
    label: 'Wallet top-up',
    icon: 'ri-add-circle-line',
    tone: 'accent',
    sourceLabel: 'Open Wallets',
  },
  fee: {
    label: 'Rail fee',
    icon: 'ri-percent-line',
    tone: 'neutral',
    sourceLabel: 'Open Payouts',
  },
  reversal: {
    label: 'Reversal',
    icon: 'ri-arrow-go-back-line',
    tone: 'outline',
    sourceLabel: 'Open Single Payment',
  },
};
